// @flow

import { type PendingIncomingPayment } from './types';

export function getSafeClabeAccount(incomingPayment: PendingIncomingPayment): string {
  const clabeAccount = incomingPayment['clabe_account'];
  if (!clabeAccount)
    throw new Error('Spei: Invalid state - There is no clabe_account property for this payment');

  return clabeAccount;
}
